import React, { useState } from 'react';
import PropTypes from 'prop-types';
import appConfig from 'app-config';
import _ from 'lodash';
import { useTranslator } from '@jutro/locale';
import { useModal } from '@jutro/components';
import { MetadataContent } from '@jutro/legacy/uiconfig';
import { MLBundleService } from 'ml-services-common-react';
import { AccountService } from 'gw-capability-gateway-policy';
import { FormModalPopover } from 'ml-components-platform-react';

import { MLNewQuoteDialogModal, MLNewQuoteDialogModalMessages } from 'gw-capability-gateway-quoteandbind-common-react';

import metadata from './MLBundleQuestionPopup.metadata.json5';
import './MLBundleQuestionPopup.messages';
import styles from './MLBundleQuestionPopup.module.scss';

const MLBundleQuestionPopup = (props) => {
    const modalApi = useModal();
    const {
        accountNumber,
        quoteNumber,
        postalCode,
        history,
        viewModelService,
        onSave,
        onError,
        authHeader
    } = props;

    const translator = useTranslator();

    const [errorMessage, updateErrorMessage] = useState(undefined);

    // TODO: extract to common util
    const parseErrorForMessage = (errorString) => {
        const indexOfMessages = errorString.indexOf('Messages_ML');
        let errorMessages = errorString.substring(indexOfMessages).split(']')[0];
        errorMessages = errorMessages.split('[')[1];
        return errorMessages.split(',')[0];
    };

    const handleError = (error) => {
        const errorMessageStringArray = error.baseError.split(' ');
        const outerErrorCodeIndex = error.baseError.indexOf('ErrorCode:');
        const outerErrorCodeValue = outerErrorCodeIndex !== -1 ? errorMessageStringArray[outerErrorCodeIndex + 1] : undefined;
        const outerErrorCodeNumericValue = !_.isUndefined(outerErrorCodeValue) ? parseInt(outerErrorCodeValue, 10) : undefined;
        if (outerErrorCodeNumericValue === appConfig.errorCodes.DISPLAYABLE_ERROR_ML) {
            updateErrorMessage(parseErrorForMessage(error.baseError));
        }
        onError(error);
    };

    const showNewQuoteDialog = (account) => {
        const accountVM = viewModelService.create(account, 'pc', 'edge.capabilities.gateway.account.dto.AccountDTO');
        const overrides = {
            model: accountVM,
            history
        };

        const componentProps = {
            title: translator(MLNewQuoteDialogModalMessages.startAQuote),
            overrideProps: overrides,
            CustomComponent: MLNewQuoteDialogModal,
            buttonType: 'outlined',
            showFooterOnCustomComponent: false,
            additionalPEStyle: 'customFooterModal',
            viewModelService,
            authHeader
        };
        modalApi.showModal(
            <FormModalPopover {...componentProps} />
        );
    };

    const startBundle = () => {
        MLBundleService.addJobToBundle(quoteNumber, authHeader)
            .then(() => {
                AccountService.getAccountDetails(accountNumber, authHeader).then((account) => {
                    onSave();
                    setTimeout(() => showNewQuoteDialog(account), 100);
                });
            })
            .catch((error)=> {
                handleError(error);
            });
    };

    const startMonoline = () => {
        MLBundleService.removeJobFromBundle(quoteNumber, authHeader)
            .then(() => {
                onSave();
                history.push('/quoteentry', {quoteID: quoteNumber, postalCode: postalCode})
            })
            .catch((error)=> {
                handleError(error);
            });
    };

    const overrides = {
        bundleButton: {
            onClick: startBundle
        },
        monolineButton: {
            onClick: startMonoline
        },
        errorMessage: {
            visible: !!errorMessage,
            content: errorMessage,
            className: styles.error
        }
    };

    const resolvers = {
        resolveClassNameMap: styles
    };

    return (
        <MetadataContent
            uiProps={metadata.componentContent}
            overrideProps={overrides}
            {...resolvers} />
    );
};

MLBundleQuestionPopup.propTypes = {
    accountNumber: PropTypes.string.isRequired,
    quoteNumber: PropTypes.string.isRequired,
    postalCode: PropTypes.string.isRequired,
    history: PropTypes.shape({}).isRequired,
    viewModelService: PropTypes.func.isRequired,
    onError: PropTypes.func
};

MLBundleQuestionPopup.defaultProps = {
    onError: _.noop
}

export default MLBundleQuestionPopup;
